import { useEffect, useState } from 'react';
import { Mixpanel } from 'utils/mixpanel';
import { createClient } from '../../prismicio';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';
import { Box, Container, Toolbar, Typography } from '@mui/material';
import styles from './setup.module.css';
import Link from 'next/link';
import Swiftask from 'common/assets/image/logo/swiftask';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import Colors from 'common/theme/saasModern/colors';

const Setup = ({ page }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    Mixpanel.track('Setup-page', {});
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const data = page.data;
  return (
    <Box className={styles.body}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          zIndex: 9999,
          paddingLeft: 32,
          backgroundColor: isScrolled
            ? Colors.backGroundNavBar
            : Colors.transparent,
          width: '100%',
        }}
      >
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Link href="/">
            <Swiftask isDark={isScrolled ? false : true} />
          </Link>
        </Toolbar>
      </Box>
      <Box className={styles.content}>
        <Container maxWidth={'xl'}>
          <Box sx={{ textAlign: 'center', py: '24px' }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: ['24px', '24px', '36px'],
                marginBottom: ['0px', '0px', '24px'],
                lineHeight: '40px',
                color: '#111927',
                '.font-semibold': {
                  color: '#FE6E72',
                },
              }}
              fontWeight={900}
            >
              <PrismicRichText field={data.headtitle} />
            </Typography>
          </Box>
          <Box
            className={styles.banner}
            display={'flex'}
            flexDirection={['column', 'column', 'row']}
            gap={[1, 1, 4]}
            alignItems={'center'}
          >
            <Box width={['100%', '100%', '37%']}>
              <Box
                sx={{
                  marginBottom: ['0px', '0px', '32px'],
                  textAlign: 'left',
                  li: {
                    py: ['4px', '4px', '8px'],
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '30px',
                    color: '#111927',
                  },
                  ul: {
                    pl: '16px',
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: '24px',
                    fontWeight: '600',
                    lineHeight: '24px',
                  }}
                >
                  {data.featureskeytitle}
                </Typography>
                <PrismicRichText field={data.featureskeys} />
              </Box>
              <Box
                sx={{
                  backgroundColor: '#F9F8F9',
                  borderRadius: '16px',
                  display: ['none', 'none', 'inherit'],
                  padding: '16px',
                  p: {
                    textAlign: 'justify',
                    fontSize: '13px',
                    fontWeight: '400',
                    lineHeight: '18px',
                  },
                  strong: {
                    fontSize: '13px',
                    fontWeight: '600',
                    lineHeight: '18px',
                  },
                }}
              >
                <PrismicRichText field={data.featureskeyinfo} />
              </Box>
            </Box>
            <Box sx={{ width: ['100%', '100%', '60%'], ml: 'auto' }}>
              <video
                autoPlay
                loop
                muted
                playsInline
                width="100%"
                style={{ borderRadius: '8px' }}
              >
                <source src={data.tutovideourl.url} type="video/mp4" />
              </video>
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: ['14px', '14px', '18px'],
              textAlign: 'center',
              color: '#888C93',
              fontWeight: '700',
              marginTop: ['24px', '24px', '40px'],
            }}
          >
            {data.footerlabel}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export const getStaticProps = async ({ locale }) => {
  const client = createClient();
  const prismicLanguage = getPrismicLanguage(locale);
  const page = await client.getSingle('chromesetup', {
    lang: prismicLanguage,
  });
  return {
    props: {
      page,
    },
  };
};
export default Setup;